import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { LibraryItem } from '../../../../entities/LibraryItem';
import DateHelper from '../../../../utilities/DateHelper';
import { DesktopRecentTableRow } from './DesktopRecentTableRow';

const useStyles = makeStyles((theme) => ({
    sectionTitle: {
        color: "#5f6368",
        fontSize: "13px",
        fontWeight: 500,
        fontFamily: "Roboto, Helvetica",
        borderBottom: "1px solid rgb(225,225,225)",
        paddingTop: "10px",
        paddingBottom: "10px",
        [theme.breakpoints.down('sm')]: {
            borderTop: "1px solid rgb(225,225,225)",
            backgroundColor: "#FFF",
            paddingLeft: "8px"
        },
    },
    listRow: {
        paddingTop: "8px",
        paddingBottom: "8px",
        borderBottom: "1px solid rgb(225,225,225)",
        "&:last-child": {
            borderBottom: "none"
        },
        cursor: "context-menu"
    },
}));

interface Props {
    title: string;
    items:LibraryItem[];
    showTimeString: boolean;
    setFocusedItemId: (itemId: string) => void;
    focusedItemId?: string;
}

export function DesktopRecentTable(props:Props){
    const { showTimeString, focusedItemId, title } = props;
    const classes = useStyles();

    return (
        <span className={classes.listRow}>
            <Typography variant="subtitle1" className={classes.sectionTitle}>
                {title}
            </Typography>
            {props.items.map((item) => {
                return (
                    <DesktopRecentTableRow
                        key={item.id}
                        item={item} 
                        dateLastModified={showTimeString 
                            ? item.dateModified.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})
                            : DateHelper.buildDateFormat(item.dateModified)
                        } 
                        setFocusedItem={(i) => props.setFocusedItemId(i)} 
                        focusedItemId={focusedItemId}
                    />    
                );
            })}
        </span>
    )
}